import React, { useEffect, useState } from "react";
import Style from "./Style";
import { useDispatch, useSelector } from "react-redux";
import { ScheduleInterviewAction } from "../../../Redux/action/ScheduleInterviewAction";
import InterviewList from "../VendorDashboard/InterviewList";
import { InterviewPlannedAction } from "../../../Redux/action/InterviewPlannedAction";
import Pagination from '../../Common/Pagination/Pagination';  


const ScheduleInterview = () => {
    const [pageNumber, setPageNumber] = useState(0);
    const totalPages = useSelector((state) => state?.InterviewPlanned?.result?.totalPages);

    const [state, setState] = useState({
        interviewId: "",
        candidateName: "",
        candidateId: "",
        interviewerName: "",
        interviewerId: "",
        companyName: "",
        jobPosition: "",
        interviewMode: "",
        interviewLink: "",
        interviewDate: "",
        interviewStartTime: "",
        interviewEndTime: "",
        inteviewType: "",
        round: "",
    });
    const { userResult } = useSelector((state) => state.Auth);
    const vendorId = userResult?.vendorid;
    const {
        candidateName,
        companyName,
        interviewerName,
        interviewId,
        interviewMode,
        candidateId,
        jobPosition,
        inteviewType,
        round,
        interviewerId,
        interviewLink,
        interviewDate,
        interviewStartTime,
        interviewEndTime,
    } = state;

    const content = {
        vendorId,
        candidateName,
        companyName,
        interviewerName,
        interviewId,
        interviewMode,
        candidateId,
        jobPosition,
        inteviewType,
        round,
        interviewerId,
        interviewLink,
        interviewDate,
        interviewStartTime,
        interviewEndTime,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
    };
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(InterviewPlannedAction(vendorId,pageNumber));
    }, [pageNumber])


    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(ScheduleInterviewAction(content));
    };

    const interviewList = useSelector((state) => state?.InterviewPlanned?.result);

    return (
        <Style>
            <div className="common_wrapper mt-4">
                <div className="">
                    {/* <TableHeader heading={'Interview Planned'} /> */}
                    {/* <div className='d-flex justify-content-center mb-5'>
                        <Link to="/interview-history">
                            <button className="schedule-button">History</button>
                        </Link>
                    </div> */}

                </div>
                <InterviewList pageNumber={pageNumber} interviewList={interviewList} />
            </div>
            {
                totalPages>0 &&
                <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
            }

        </Style>
    );
};

export default ScheduleInterview;
